<ng-container *ngIf="loading">
    <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading">
    <div class="margin-top mt24 mb-4 col-2d373d fs-16 lh-20-83" [formGroup]="formGroup"> 
        <div class="blue-msg-box mb-4">
            <div class="icon-section">
                <img src="./assets/img/images/blue-info-icon.svg" class="blue-info-icon" alt="">
            </div>
            <div class="msg-section">
                <ng-container *ngIf="typeOfReason.includes('uncashed refund letter'); else refundApprovedDesc">
                    {{ 'UNCASHED_REFUND_LETTER_APPROVED' | translate }}
                </ng-container>
                <ng-template #refundApprovedDesc>
                    {{ 'REFUND_APPROVED' | translate }}
                </ng-template>
            </div>
        </div>

        <div class="fs-16 fw-700 lh-normal">{{'DIGITAL_REFUND' | translate }}</div>

        <div class="info-container checkbox col-526570 fs-14 mt-3 lh24 custom-input">
            <div class="d-inline">
                <input type="radio" class="radio-button" id="digital-refund-yes" name="isDigitalRefund" 
                    [formControlName]="'isDigitalRefund'" [value]="true">
                <label class="no-margin-bottom align-top" for="digital-refund-yes">{{ 'Yes' }}</label>
            </div> 
            <div class="ml-3">
                <input type="radio" class="" id="digital-refund-no" name="isDigitalRefund" 
                    [formControlName]="'isDigitalRefund'" [value]="false">
                <label class="no-margin-bottom align-top" for="digital-refund-no">{{ 'No' }}</label>
            </div>   
        </div>

        <div *ngIf="isDigitalRefund !== null" class="mb-4">
            <div class="mt-4 mb-2">{{'CONFIRM_INFO_TO_REFUND' | translate }}</div>

            <div class="info-container col-DF0027 mb-3">
                <img src="assets/img/images/icon-info-red.svg" alt="info icon"/>
                <span>{{'UPDATE_CORRECT_INFO_TO_POLICY' | translate }}</span>
            </div>

            <ng-container *ngIf="isDigitalRefund; else noDigital">
                <ng-container *ngIf="showEmailEditField; else showEmail">        
                    <div class="row mr-0 ml-0 input-field mapfre custom-input">
                        <label for="'email'" class="select-label mb-0">{{ "Email" | translate }}</label>
                        <input id="email" type="email" formControlName="email"
                            class="form-control" placeholder="name@email.com" 
                            [ngClass]="{ error: showEmailError }"
                            (input)="clearError('email')" (blur)="emailValidationOnBlur()"
                        />
                        <div *ngIf="showEmailError" class="help-block error-block">
                            <span *ngIf="formGroup.get('email')?.errors?.required">
                                {{ "Enter an email" | translate }}
                            </span> 
                            <span *ngIf="formGroup.get('email')?.errors?.pattern">
                                {{ "Enter a valid email address" | translate }}
                            </span>                                           
                        </div>                                                                
                    </div>
                    <div class="info-container mt-1 w-500">
                        <p class="btn-without-border col-526570 mr-3 mb-0" (click)="resetEditingEmail()"> 
                            {{ 'CANCEL' | translate }} 
                        </p> 
                        <p class="btn-without-border col-DF0027" (click)="saveEditedEmail()"> 
                            {{ 'Save' | translate }} 
                        </p> 
                    </div>
                </ng-container>
                <ng-template #showEmail>
                    <div class="mb-1 col-89969A lh-24">
                        {{ 'EMAIL' | translate }}                                     
                    </div>
                    <div class="mt-1 lh-24 fw-500 dm-sans-medium">
                        <div>{{ userDetails.updatedEmail }}</div>
                        <div class="btn-without-border col-DF0027 mt-1 mb-3 fw-500" (click)="showEditField('email')"> 
                            {{ 'EDIT' | translate }} 
                        </div>                                    
                    </div>
                </ng-template>

                <ng-container *ngIf="showPhoneEditField; else showPhone">        
                    <div class="row mr-0 ml-0 input-field mapfre custom-input">
                        <label for="'phone'" class="select-label mb-0">{{ "Phone" | translate }}</label>
                        <input id="phone" type="tel" formControlName="phone" class="form-control" 
                            placeholder="123-123-1234"
                            [ngClass]="{ error: showPhoneError }" 
                            appInputPhoneFormatter 
                            (blur)="phoneValidationOnBlur()"
                            (input)="clearError('phone')" 
                        />
                        <div *ngIf="showPhoneError" class="help-block error-block">
                            <span *ngIf="formGroup.get('phone')?.errors?.required">
                                {{ "Enter a phone number" | translate }}
                            </span> 
                            <span *ngIf="formGroup.get('phone')?.errors?.minlength">
                                {{ "Enter a valid phone number" | translate }}
                            </span>                                           
                        </div>                                                                
                    </div>
                    <div class="info-container mt-1 w-500">
                        <p class="btn-without-border col-526570 mr-3 mb-0" (click)="resetEditingPhone()"> 
                            {{ 'CANCEL' | translate }} 
                        </p> 
                        <p class="btn-without-border col-DF0027 mb-0" (click)="saveEditedPhone()"> 
                            {{ 'Save' | translate }} 
                        </p> 
                    </div>
                </ng-container>
                <ng-template #showPhone>
                    <ng-container>
                        <div class="mb-1 col-89969A lh-24">
                            {{ 'Phone number' | translate }}
                        </div>
                        <div class="mt-1 lh-24 fw-500 dm-sans-medium">
                            <div [ngClass]="{'mb-2' : !userDetails?.updatedPhoneNumber}">
                                {{ userDetails?.updatedPhoneNumber }}
                            </div>
                            <div class="btn-without-border col-DF0027 mt-1 pb-2" (click)="showEditField('phone')">
                                {{ 'EDIT' | translate }}
                            </div>
                        </div>
                    </ng-container>
                </ng-template>
            </ng-container>
            <ng-template #noDigital>
                <div class="blue-msg-box mb-3 mt-0">
                    <div class="icon-section">
                        <img src="./assets/img/images/blue-info-icon.svg" class="blue-info-icon" alt="">
                    </div>
                    <div class="msg-section">
                        {{ "IF_PAYEE_INCORRECT" | translate}}
                        <a routerLink='/contact' class="see-dec nobr">
                            {{ 'CONTACT_YOUR_AGENT' | translate | lowercase}}</a> 
                        {{ 'HAVE_POLICY_CORRECTED' | translate | lowercase}}
                    </div>
                </div>

                <div class="mb-1 col-89969A lh-24">
                    {{ 'Payee' | translate }}                                     
                </div>
                <div class="mt-1 lh-24 fw-500 mb-3 dm-sans-medium">
                    <div>{{ userDetails.primaryInsuredName }}</div>
                    <div *ngIf="userDetails.secondInsuredName"> {{ userDetails.secondInsuredName }} </div>                                    
                </div>

                <ng-container *ngIf="showMailingAddressEditFields; else showMailingAddress">        
                    <!-- <div class="row mr-0 ml-0 input-field mapfre custom-input"> -->
                    <div class="row mr-0 ml-0 mapfre custom-input">
                        <label for="'street'" class="select-label mb-0">{{ "MAILING_ADDRESS" | translate }}</label>
                        <input id="street" type="text" formControlName="street" class="form-control font-size-16 col-9CB0BC" 
                            placeholder="Street address" (input)="clearError('street')" (blur)="isValidInput('Street', 'street')" 
                            [ngClass]="{ error: showStreetError }"
                        />                           
                        <div *ngIf="showStreetError" class="help-block error-block">
                            {{ "Enter a street address" | translate }}                                          
                        </div> 
                        <div class="address-group mt-3">
                            <div class="address-item">
                                <input id="city" type="text" formControlName="city" class="form-control font-size-16 col-9CB0BC" 
                                [ngClass]="{ error: showCityError }" placeholder="City" 
                                (input)="clearError('city')" (blur)="isValidInput('City', 'city')"
                                />
                                <div *ngIf="showCityError" class="help-block error-block">
                                    {{ "Enter a city" | translate }}                                          
                                </div> 
                            </div>

                            <div class="address-item">
                                <div class="ng-select-main refund-custom-select">
                                <!-- <select class="custom-select-font font-size-16 col-9CB0BC" 
                                    [ngClass]="{'billing-select-errorr': showStateError, 'custom-select': true}"
                                    id="state" formControlName="state" (change)="clearError('state')" (blur)="isValidInput('State', 'state')"
                                >  
                                    <option disabled [selected] value="">State</option> 
                                    <option *ngFor="let state of states" [value]="state.abv">
                                        {{ state.fullStateName }}
                                    </option>
                                </select> -->
                                <ng-select 
                                [items]="states" 
                                bindLabel="fullStateName" 
                                [autofocus]="false" 
                                bindValue="fullStateName" 
                                [searchable]="false" 
                                [multiple]="false"
                                [clearable]="false" 
                                [markFirst]="false" 
                                placeholder="State" 
                                fixedPlaceholder="true"
                                [formControlName]="'state'"
                                (change)="clearError('state')"
                                (blur)="isValidInput('State', 'state')"
                                [ngClass]="{ 'validation-error' : showStateError }"> 
                                </ng-select>
                                <div *ngIf="showStateError" class="help-block error-block">
                                    {{ "Select a state" | translate }}                                          
                                </div>
                            </div>
                            </div>

                            <div class="address-item custom-input">
                                <input class="form-control font-size-16 col-9CB0BC" 
                                    [ngClass]="{ error: showZipCodeError }" id="zipCode" type="tel" formControlName="zipCode" 
                                    placeholder="Zip code" (input)="clearError('zipCode')" (blur)="isValidInput('ZipCode', 'zipCode')" maxlength="5" minlength="5" mdbInput
                                />
                                <div *ngIf="showZipCodeError" class="help-block error-block">
                                    <ng-container *ngIf="formGroup.get('zipCode')?.errors?.required; else invalidZipCode">
                                        {{ "Enter a zip code" | translate }}
                                    </ng-container> 
                                    <ng-template #invalidZipCode>
                                        {{ "Enter a valid zip code" | translate }}
                                    </ng-template>                                             
                                </div> 
                            </div>
                        </div>
                        
                    </div>
                    <div class="info-container mt-1 w-500">
                        <p class="btn-without-border col-526570 mr-3 mb-0" (click)="resetMailingAddress()"> 
                            {{ 'CANCEL' | translate }} 
                        </p> 
                        <p class="btn-without-border col-DF0027 mb-0" (click)="saveMailingAddress()"> 
                            {{ 'Save' | translate }} 
                        </p> 
                    </div>
                </ng-container>
                <ng-template #showMailingAddress>
                    <div class="mb-1 col-89969A lh-24">
                        {{ 'MAILING_ADDRESS' | translate }}                                     
                    </div>
                    <div class="mt-1 lh-24 fw-500 dm-sans-medium">
                        <div>{{ userDetails.updatedMailingAddress.streetName }}</div>
                        <div>
                            {{ userDetails.updatedMailingAddress.city }}, {{ userDetails.updatedMailingAddress.stateCode }} {{ userDetails.updatedMailingAddress.zipCode.code }}
                        </div>
                        <div class="btn-without-border col-DF0027 mt-1" (click)="showEditField('mailingAddress')"> 
                            {{ 'EDIT' | translate }} 
                        </div>                                    
                    </div>
                </ng-template>
            </ng-template>
        </div>        
    </div>    
</ng-container>
